import React from "react";
import PropTypes from "prop-types";
import {
  FaCheck,
  FaTimes,
  FaArrowLeft,
  FaPlus,
  FaEdit,
  FaInfoCircle,
} from "react-icons/fa";
import "./MultiStyleButton.css";

const MultiStyleButton = ({ label, buttonType, onClick, disabled = false }) => {
  let buttonClass = "multi-style-button-comp";
  let IconComponent = null;

  switch (buttonType) {
    case "wide":
      buttonClass += " wide-button";
      break;
    case "fixed":
      buttonClass += " fixed-button";
      break;
    case "square":
      buttonClass += " square-button";
      break;
    case "round":
      buttonClass += " round-button";
      break;
    case "cancel":
      buttonClass += " cancel-button";
      IconComponent = FaTimes;
      break;
    case "approve":
      buttonClass += " approve-button";
      IconComponent = FaCheck;
      break;
    case "back":
      buttonClass += " back-button";
      IconComponent = FaArrowLeft;
      break;
    // NEW: wide-approve
    case "wide-approve":
      buttonClass += " wide-button approve-button";
      IconComponent = FaCheck;
      break;
    // NEW: wide-cancel
    case "wide-cancel":
      buttonClass += " wide-button cancel-button";
      IconComponent = FaTimes;
      break;
    // NEW: add button
    case "add":
      buttonClass += " add-button";
      IconComponent = FaPlus;
      break;
    // NEW: edit button
    case "edit":
      buttonClass += " edit-button";
      IconComponent = FaEdit;
      break;
    // NEW: close button
    case "close":
      buttonClass += " close-button";
      IconComponent = FaTimes;
      break;
    // NEW: info button
    case "info":
      buttonClass += " info-button";
      IconComponent = FaInfoCircle;
      break;
    default:
      break;
  }

  return (
    <button className={buttonClass} onClick={onClick} disabled={disabled}>
      {IconComponent && <IconComponent className="button-icon" />}
      {label}
    </button>
  );
};

MultiStyleButton.propTypes = {
  label: PropTypes.string.isRequired,
  buttonType: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default MultiStyleButton;
